import { Injectable } from '@angular/core';
import { SharesApiProviderService } from '@core/api';
import { Store } from '@ngrx/store';
import { catchError, Observable, tap } from 'rxjs';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { PromptService } from 'src/app/project/components/prompt/prompt.service';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { setChangedAccounts } from 'src/app/project/modules/account/account';
import { ResponseErrorService } from 'src/app/project/modules/errors/response-error.service';
import { SidePanelSitesListService } from 'src/app/project/modules/layout/side-panel-sites-list/side-panel-sites-list.service';
import { TShare } from 'src/app/project/modules/share/share.model';
import { setChangedWorkspaces } from 'src/app/project/modules/workspace/workspace';
import { DeleteWorkspace } from 'src/app/project/modules/workspace/workspace.actions';
import { EditNotificationsModalComponent } from '../../../edit-notifications-modal/edit-notifications-modal.component';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsSitesDropdownService {
  constructor(
    private sidePanelSitesListService: SidePanelSitesListService,
    private store: Store,
    private sharesApiProviderService: SharesApiProviderService,
    private responseErrorService: ResponseErrorService,
    private promptService: PromptService,
    private translationPipe: TranslationPipe,
    private modalService: ModalService,
  ) {}

  showAllSites(): Observable<TShare[]> {
    return this.sharesApiProviderService.showAllSites().pipe(
      tap((response) => {
        const prompt = this.translationPipe.transform('prompt_sites_show_all_success');
        this.promptService.showSuccess(prompt);

        this.handleBulkChangeSuccess(response, true);
      }),
      catchError((error) => {
        const prompt = this.translationPipe.transform('prompt_sites_show_all_error');
        this.promptService.showError(prompt);

        return this.responseErrorService.handleRequestError(error);
      }),
    );
  }

  hideAllSites(): Observable<TShare[]> {
    return this.sharesApiProviderService.hideAllSites().pipe(
      tap((response) => {
        const prompt = this.translationPipe.transform('prompt_sites_hide_all_success');
        this.promptService.showSuccess(prompt);

        this.handleBulkChangeSuccess(response, false);
      }),
      catchError((error) => {
        const prompt = this.translationPipe.transform('prompt_sites_hide_all_error');
        this.promptService.showError(prompt);

        return this.responseErrorService.handleRequestError(error);
      }),
    );
  }

  handleBulkChangeSuccess(shares: TShare[], visible: boolean): void {
    this.sidePanelSitesListService.markForRefresh();

    if (!visible) {
      shares.forEach((share) => {
        this.store.dispatch(
          new DeleteWorkspace({
            workspaceId: share.workspaceId,
          }),
        );
      });
    }

    setChangedWorkspaces(true);
    setChangedAccounts(true);
  }

  showBulkDigestModal(): void {
    this.modalService.setData(null);
    this.modalService.showModal(EditNotificationsModalComponent);
  }
}
